@if (message()) {
  <p class="vault-field-error" role="alert" aria-live="polite">{{ message() }}</p>
}
